import React from 'react';
import './SkeletonCard.css';

export default function SkeletonCard() {
  return (
    <div className="skeleton-card">
      <div className="skeleton-preview shimmer-bg"></div>
      <div className="skeleton-info">
        <div className="skeleton-title shimmer-bg"></div>
        <div className="skeleton-subtitle shimmer-bg"></div>
        <div className="skeleton-meta">
          <div className="skeleton-badge shimmer-bg"></div>
          <div className="skeleton-badge shimmer-bg"></div>
        </div>
      </div>
    </div>
  );
}
